import { render, staticRenderFns } from "./ActionHeader.vue?vue&type=template&id=7b461104&scoped=true&"
var script = {}
import style0 from "./ActionHeader.vue?vue&type=style&index=0&id=7b461104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b461104",
  null
  
)

export default component.exports